document.addEventListener("DOMContentLoaded", function () {

    const boxTimeline = document.querySelector('.boxTimeline');

    if (!!boxTimeline) {
        const navMore = document.querySelectorAll('.nav-more');
        const sliderItems = boxTimeline.querySelectorAll('.item');
        const slider = document.querySelector('.boxSlider');
        const year = slider.querySelector('.yearSlider');
        const desc = {
            title: slider.querySelector('.descSlider h3'),
            description: slider.querySelector('.descSlider p')
        };
        const nav = document.querySelector('.m-nav');
        const navPage = nav.querySelector('.page');
        const navPrev = nav.querySelector('.prev');
        const navNext = nav.querySelector('.next');

        function smoothScroll(target, duration) {
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            let startTime = null;

            function animation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const run = ease(timeElapsed, window.pageYOffset, targetPosition - window.pageYOffset, duration);
                window.scrollTo(0, run);
                if (timeElapsed < duration) requestAnimationFrame(animation);
            }

            function ease(t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            }

            requestAnimationFrame(animation);
        }

        navMore.forEach(navItem => {
            navItem.addEventListener('timeLineOpen', () => {
                boxTimeline.classList.add('active');
                navMore.forEach(item => item.classList.add('active'));
                boxTimeline.style = '--h: ' + boxTimeline.querySelector('.inner').offsetHeight + 'px';
            });

            navItem.addEventListener('timeLineClose', () => {
                boxTimeline.classList.remove('active');
                navMore.forEach(item => item.classList.remove('active'));
                boxTimeline.style = '--h: 0px';

                const section = document.querySelector('#timeLine');
                smoothScroll(section, 1000);
            });

            navItem.addEventListener('click', () => {
                if (navItem.classList.contains('active')) {
                    navItem.dispatchEvent(new Event('timeLineClose'));
                } else {
                    navItem.dispatchEvent(new Event('timeLineOpen'));
                }
            });

            window.addEventListener('resize', () => {
                if (navItem.classList.contains('active')) {
                    navItem.dispatchEvent(new Event('timeLineClose'));
                }
            });
        });

        slider.style.transition = 'opacity .3s';

        let i = 0;
        let interval;

        function animateSlider() {
            slider.style.opacity = 0;

            setTimeout(function () {
                year.innerHTML = sliderItems[i].dataset.year;
                appendContent(sliderItems[i]);
                slider.style.opacity = 1;
            }, 300);

            i++;
            if (i >= sliderItems.length) {
                i = 0;
            }

            let page = i + 1 + '/' + sliderItems.length;
            navPage.innerHTML = page;

            interval = setTimeout(animateSlider, 5000);
        }

        function toggleInterval() {
            if (interval) {
                clearTimeout(interval);
                interval = null;
            } else {
                interval = setTimeout(animateSlider, 5000);
            }
        }

        function changeSlide(direction) {
            i += direction;
            if (i < 0) {
                i = sliderItems.length - 1;
            } else if (i >= sliderItems.length) {
                i = 0;
            }
            slider.style.opacity = 0;

            setTimeout(function () {
                year.innerHTML = sliderItems[i].dataset.year;
                appendContent(sliderItems[i]);
                slider.style.opacity = 1;
            }, 300);
            let page = i + 1 + '/' + sliderItems.length;
            navPage.innerHTML = page;
        }

        function appendContent(slide) {
            const titleEl = slide.querySelector('h3')
            const textEl = slide.querySelector('p')

            desc.title.textContent = titleEl.textContent
            desc.description.textContent = textEl.textContent
        }

        animateSlider();

        slider.addEventListener('mouseenter', toggleInterval);
        slider.addEventListener('mouseleave', toggleInterval);
        nav.addEventListener('mouseenter', toggleInterval);
        nav.addEventListener('mouseleave', toggleInterval);

        // navigation buttons next and prev
        navPrev.addEventListener('click', function () {
            changeSlide(-1);
        });

        navNext.addEventListener('click', function () {
            changeSlide(1);
        });
    }
});